export default "__VITE_ASSET__FQtJjdUz__"